import { useMemo, type ReactNode } from 'react'
import {
  ConnectionProvider,
  WalletProvider
} from '@solana/wallet-adapter-react'
import { PhantomWalletAdapter } from '@solana/wallet-adapter-wallets'
import {
  SOLANA_RPC_ENDPOINT,
  SOLANA_WALLET_LOCAL_STORAGE_KEY
} from './solana-config'

export const SolanaProviders = ({ children }: { children: ReactNode }) => {
  const endpoint = useMemo(() => SOLANA_RPC_ENDPOINT, [])
  const wallets = useMemo(() => [new PhantomWalletAdapter()], [])

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider
        wallets={wallets}
        autoConnect
        localStorageKey={SOLANA_WALLET_LOCAL_STORAGE_KEY}
      >
        {children}
      </WalletProvider>
    </ConnectionProvider>
  )
}
